import { Link } from '@mui/material'
import { routePaths } from './route-paths'
import { prepareRoutes } from './utils/prepareRoutes'

export const useTemplateQuestionRoutes = () => {
	return prepareRoutes(
		[
			{
				path: routePaths.templateQuestions.root,
				lazy: () =>
					import('pages/template-questions/template-questions').then((module) => ({
						Component: module.TemplateQuestionsPage,
					})),
				handle: {
					crumb: () => <Link href={routePaths.templateQuestions.root}>Template Questions</Link>,
				},
			},
		],
		{},
	)
}
